// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { instalarInterceptorDeRede } from './api/interceptor';
import App from './App';
import { ConfigProvider } from './components/ConfigContext';
import { EventConfigProvider } from './hooks/useEventConfig';
import { CustomThemeProvider } from './theme/ThemeProvider';

// Antes de qualquer requisição: escopo de evento e teto de espera.
// Cobre as chamadas por `fetch`; as por axios são tratadas em utils/api.ts.
instalarInterceptorDeRede();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <CustomThemeProvider>
      {/* Identidade visual do evento, vinda da API e cacheada localmente. */}
      <EventConfigProvider>
        <ConfigProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </EventConfigProvider>
    </CustomThemeProvider>
  </React.StrictMode>
);
